import React from 'react';

import PersonIcon from '@mui/icons-material/Person';
import { Chip } from '@mui/material';
import { Avatar, Box, ListItemButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const ResultItem = ({
    clearSearch,
    extraContent,
    icon = <PersonIcon />,
    isArchived = false,
    mainContent,
    to,
}) => {
    const { t } = useTranslation();
    return (
        <ListItemButton
            onClick={clearSearch}
            component={RouterLink}
            sx={{
                display: 'block',
                fontSize: '12px',
                fontWeight: 'bold',
                mb: 1,
                width: '100%',
                ':focus': { outline: '1px solid' },
            }}
            to={to}
            underline="none"
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Box>
                    <Avatar>{icon}</Avatar>
                </Box>
                <Box sx={{ color: 'secondary.text', flexGrow: 1 }}>
                    <Box sx={{ fontSize: '14px', fontWeight: '600' }}>
                        {mainContent}
                    </Box>
                    <Box sx={{ fontSize: '10px', fontWeight: '500' }}>
                        {extraContent}
                    </Box>
                </Box>
                <Box hidden={!isArchived}>
                    <Chip
                        label={t('Archived')}
                        size="small"
                        sx={{ fontSize: '10px' }}
                    />
                </Box>
            </Box>
        </ListItemButton>
    );
};

ResultItem.propTypes = {
    clearSearch: PropTypes.func,
    extraContent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    icon: PropTypes.node,
    isArchived: PropTypes.bool,
    mainContent: PropTypes.node,
    to: PropTypes.node,
};

export default ResultItem;
